import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/pexels-coffee.webp?nf_resize=fit&w=500'


const _hoisted_1 = { class: "h-screen grid grid-cols-1 sm:grid-cols-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "justify-self-center sm:justify-self-end self-end sm:self-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "h-48 sm:h-64 w-auto",
    width: "64",
    height: "48"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-600 font-mono" }, " photo by Jason Villanueva from Pexels ")
], -1)
const _hoisted_3 = { class: "pt-4 px-8 justify-self-center sm:justify-self-start self-start sm:self-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-5xl font-medium font-primary text-black" }, " All done!! Time to relax ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "py-2 px-1 text-xl text-primary font-secondary" }, " with a nice hot cup of coffee. Your response has been recorded. ", -1)

import SolidButtonVue from "@/components/particles/SolidButton.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createVNode(SolidButtonVue, {
            text: 'Go Back Home',
            class: "mt-4"
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})